import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import aboutMeIllustration from "../assets/about_me.svg";
import aboutMeIllustrationMobile from "../assets/about_me_up.svg";
import { useGlobaleContext } from "../context";
const AboutPage = () => {
  const btn = useRef();
  const { toggleHoverAnimation, MagneticBtn } = useGlobaleContext();

  const [illustration, setIllustration] = useState(() => {
    return window.innerWidth <= 635
      ? aboutMeIllustrationMobile
      : aboutMeIllustration;
  });

  const handleMouseMove = (e) => {
    MagneticBtn(e, btn);
  };

  const changeIllustration = () => {
    if (window.innerWidth <= 635) {
      setIllustration(aboutMeIllustrationMobile);
      return;
    }
    setIllustration(aboutMeIllustration);
  };

  // change the illustration for mobile
  useEffect(() => {
    window.addEventListener("resize", changeIllustration);

    return (_) => {
      window.removeEventListener("resize", changeIllustration);
    };
  }, []);

  return (
    <Wrapper>
      <section onMouseMove={handleMouseMove}>
        <h1 className="font-face-js section-heading">
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            A
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            b
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            o
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            u
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            t
          </span>
          &nbsp;
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            m
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            e
          </span>
        </h1>
        <p>
          Hey there, my name is Abdelghani and I am based in Tlemcen, Algeria. I
          am passionate about creating things for the <b>Web</b>. I started my
          journey as a developer when I came across a fb post discussing the
          benefits of FreeCodeCamp, so I decided to try it out on the weekend. I
          was blown away by what we could do with a few lines of code
          (displaying images, videos, text...), and from that moment on, I was
          hooked.
        </p>
        <p>
          Ultimately, I would like to work for a company where I can grow
          professionally in the software/web development field. It has always
          been my <b>passion</b> to <b>write code</b>. As such, I am eager to
          dive into this field further.
        </p>
        {/* 
         some HR guys can be very judgmental about personality-related stuff.
          */}
        {/* <p>
          Besides coding, I like competitive FPS games, long runs in nature,
          calisthenics, and making people laugh.
        </p> */}

        {/* 
        when I go to resume, it’s opening at the same tab. What if I wanna switch between resume and portfolio?
        suggestion
        make link to a resume to open in the new tab

         */}
        <a
          ref={btn}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="abdelghani Mahammedi resume"
          href="https://drive.google.com/file/d/1Hk0gFnrosEhp8doWZws__uEw7BYZ_0e7/view"
          className="btn"
        >
          My Resume
        </a>
      </section>
      <img
        className="illustration"
        src={illustration}
        alt="about Me Illustration"
      />
    </Wrapper>
  );
};

const Wrapper = styled.main`
  @media (max-width: 635px) {
    section {
      padding: 0 3rem !important;
      margin: 5vh 0 !important;
      align-items: center;
    }
    .illustration {
      height: 31vh !important;
      width: 75vw !important;
    }
  }
  section {
    /* padding-top: 2rem; */
  }
  .btn {
    width: max-content;
    color: var(--colors-accent-300);
    &:hover {
      color: var(--colors-white);
    }
  }
`;

export default AboutPage;
